<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table {
  height: 534px;
  margin: 0 auto;
  padding: 30px 10px;
  color: #fff;
  text-align: center;
  overflow: hidden;

  .swiper-wrap {
    height: 520px;
    overflow: hidden;
  }

  .main {
    width: 100%;
    height: 100%;

    .list-item {
      &:nth-child(even) {
        background: #123EB5;
      }

      height: 50px;
      line-height: 50px;
      display: flex;

      .item:nth-child(1) {
        width: 50%;
      }

      .item:nth-child(2) {
        width: 25%;
      }

      .item:nth-child(3) {
        width: 25%;
      }
    }

    .list-item1 {
      background: #1A5CD1;
      color: #00FEFB;
    }
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="table">
      <div class="main">
        <div class="list-item list-item1">
          <div class="item">产品名称</div>
          <div class="item">码关联数量</div>
          <div class="item">扫码数量</div>
        </div>
        <swiper :options="swiperOption" class="swiper-wrap" ref="mySwiper" v-if="tableData.length != 0">
          <swiper-slide v-for="(item, index) in tableData" :key="index" class="list-item">
            <div class="item">{{ item.name }}</div>
            <div class="item">{{ item.codeNum }}</div>
            <div class="item">{{ item.scanNum }}</div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from 'components/dashboard/common/boxWrap';
import '../../../../static/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      name: '追溯产品展示old',
      tableData: [
        { name: '百色芒果', codeNum: 16154, scanNum: 16154 },
        { name: '圣女果', codeNum: 11523, scanNum: 9713 },
        { name: '牛心李', codeNum: 14316, scanNum: 7351 },
        { name: '西林火姜', codeNum: 10126, scanNum: 4018 },
        { name: '八渡笋', codeNum: 11256, scanNum: 4115 },
        { name: '田东香芒', codeNum: 13256, scanNum: 4301 },
        { name: '砂糖橘', codeNum: 16154, scanNum: 16154 },
        { name: '桂七香芒', codeNum: 16154, scanNum: 16154 },
        { name: '乐业猕猴桃', codeNum: 16154, scanNum: 16154 }
      ],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 170,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  mounted() {

  }
}

</script>



// WEBPACK FOOTER //
// index.vue?4bd5a74a